declare module 'crypto-helpers' {
  const sha256: (data: string) => Promise<string>
  const encodeBase64: (data: string) => string
  const decodeBase64: (data: string) => string
  const randomString: (length: number) => string
}

module.exports = __CLIENT__ ? require('./client') : require('./server')
